var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-container"},[_c('paragraph',{attrs:{"text":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }